import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { TypeAnimation } from 'react-type-animation';
import Label from '@/components/form/Label/Label';
import { useSelector } from 'react-redux';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import './NewHomeSlider.scss';

const AnimationTitle = props => {
  const { sequence } = props;
  return (
    <TypeAnimation
      sequence={sequence}
      wrapper="strong"
      className={'text-45 lineHeight-1-21 margb20'}
      speed={20}
      style={{ display: 'inline-block' }}
      repeat={Infinity}
    />
  );
};

const SliderBox = props => {
  const {
    sequence,
    personalizedPlaceholder,
    showNewForm,
    dynamickey,
    languageData,
  } = props;
  return (
    <FlexContainer className={'sliderInfo-box flex-column align-items-center'}>
      <FlexContainer
        className="flex-column align-items-center text-center padlr30 padtb30"
        style={{
          background: '#5B73B9',
          borderRadius: '30px',
          maxWidth: '520px',
          width: '90%',
          boxShadow: '0px 12px 40px rgba(0,0,0,0.35)',
        }}
      >
        {/* Title */}
        <Label
          className={`fontWhite font-bold margb16 ${
            languageData === 'EN' ? 'text-24' : 'text-20'
          }`}
        >
          {languageData === 'EN'
            ? "Psst... We're Mobile-Only Right Now"
            : 'Psst... Por ahora solo estamos en móvil'}
          🚀{' '}
        </Label>

        {/* Description */}
        <Label
          className="fontWhite text-20 margb12"
          style={{ lineHeight: '1.8' }}
        >
          {languageData === 'EN' ? (
            <>
              To book your perfect coworking spot and see <br />
              everything we’ve got, head over to our website on <br /> your
              phone. We’re cooking up the desktop <br />
              version, stay tuned!
            </>
          ) : (
            <>
              Para reservar tu espacio de coworking ideal y ver <br />
              todo lo que ofrecemos, ingresa desde tu <br /> celular. Estamos
              preparando la versión de
              <br /> escritorio — ¡muy pronto!
            </>
          )}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

const NewHomeSlider = props => {
  const {
    spacesData,
    personalizedContainerClass,
    sequence,
    personalizedPlaceholder,
    imagesArray,
    showNewForm,
  } = props;
  const languageIsFromButton = useSelector(state => state.lenguage?.isButton);
  const languageData = useSelector(state => state.lenguage?.lang);
  const [heroSwiper, setSwiperRef] = useState(null);
  const [dynamicKey, setDynamicKey] = useState(1);

  useEffect(() => {
    if (languageIsFromButton) {
      setDynamicKey(Math.random());
    }
  }, [languageIsFromButton, languageData]);

  const playHero = () => {
    heroSwiper.autoplay.start();
  };
  const pauseHero = () => {
    heroSwiper.autoplay.stop();
  };
  const containerClass =
    'mySwiper items-align-center ' + personalizedContainerClass;
  return (
    <FlexContainer column className={containerClass}>
      <SliderBox
        dynamickey={dynamicKey}
        playHero={playHero}
        pauseHero={pauseHero}
        showNewForm={showNewForm}
        spacesData={spacesData}
        sequence={sequence}
        languageData={languageData}
        personalizedPlaceholder={personalizedPlaceholder}
      />
      <Swiper
        dynamickey={dynamicKey}
        onSwiper={setSwiperRef}
        navigation
        autoplay={{
          delay: 10500,
          disableOnInteraction: true,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={0}
        slidesPerView={1}
      >
        {imagesArray.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image}
              alt={`Slider ${index + 1}`}
              style={{ width: '100%' }}
              className="sliderImage"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </FlexContainer>
  );
};

export default NewHomeSlider;
